import getEnvironmentName from './getEnvironmentName';

// Allow-list so prod ignores ?labelDate even if its env name fails to resolve
const LABEL_PREVIEW_ENVIRONMENTS = ['test', 'stg-next', 'local'];

const HOT_BUY = { label: 'Hot Buy', color: 'orange' };

// Midnight Pacific as UTC, never a local date (server and browser differ)
const PRODUCT_LABEL_OVERRIDES = [
  {
    ...HOT_BUY,
    start: Date.parse('2026-11-02T08:00:00Z'),
    end: Date.parse('2026-12-08T08:00:00Z'), // exclusive, last day is Dec 7
    productIds: [
      13540,
      15202,
      8579,
      8851,
      10566,
      12817,
      12884,
      11274,
      9546,
      571,
    ],
  },
  {
    ...HOT_BUY,
    start: Date.parse('2026-12-01T08:00:00Z'),
    end: Date.parse('2026-12-08T08:00:00Z'),
    productIds: [12815, 11246, 3374],
  },
];

// QA on dev and staging: ?labelDate=2026-12-01 shows the labels for that day
export const getLabelPreviewTime = labelDate => {
  if (
    !labelDate ||
    !LABEL_PREVIEW_ENVIRONMENTS.includes(getEnvironmentName())
  ) {
    return undefined;
  }

  // Noon Pacific keeps a plain date clear of the midnight boundaries
  const time = Date.parse(
    /^\d{4}-\d{2}-\d{2}$/.test(labelDate)
      ? `${labelDate}T12:00:00-08:00`
      : labelDate
  );

  return Number.isNaN(time) ? undefined : time;
};

const getProductLabelOverride = (productId, now = Date.now()) => {
  const id = Number(productId);

  return (
    PRODUCT_LABEL_OVERRIDES.find(
      ({ start, end, productIds }) =>
        productIds.includes(id) && now >= start && now < end
    ) ?? null
  );
};

export default getProductLabelOverride;
